import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from '../../MaterialIcon/MaterialIcon';
import classNames from 'classnames';
import styles from '../_slider.module.scss';

function CustomArrow({ className, icon, onClick, ariaLabel }) {
    return (
        <MaterialIcon onClick={onClick} className={classNames([styles.arrow, className])} icon={icon} label={ariaLabel}
            tabIndex={0}
            role="button"
        />
    );
}

CustomArrow.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    icon: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string
};

export default CustomArrow;